import { Component } from '@angular/core';
import { TranslateService } from '../i18n/translate.service';

@Component({
  selector: 'app-job-experience',
  templateUrl: './job-experience.component.html',
  styleUrls: ['./job-experience.component.scss']
})
export class JobExperienceComponent {
  name = 'Alessandro Bompadre';
  constructor(public translate: TranslateService) {}

  // helper to pick localized field: expects fields like description_en, description_it
  getLocalized(item: any, field: string) {
    const lang = this.translate.getLang();
    const key = `${field}_${lang}`;
    return item[key] || item[field] || '';
  }

  jobs = [
    {
      company: 'GFT Italia',
      location: 'Italy',
      title: 'Front End Development Manager',
      period: 'gen 2025 - Presente',
      duration: '1 anno 3 mesi',
      description_it: 'Guida la delivery front-end su progetti enterprise, coordinando persone, priorita e qualita tecnica. Gestisce il ciclo di rilascio end-to-end e supporta il team nella risoluzione di criticita applicative. Collabora con stakeholder e team cross-funzionali per garantire continuita e valore di business.',
      description_en: 'Leads front-end delivery on enterprise projects, coordinating people, priorities, and technical quality. Owns end-to-end release management and supports the team in resolving application-critical issues. Works closely with stakeholders and cross-functional teams to ensure continuity and business value.',
      skills: ['Project Management','People Leadership','Angular','Java','CI/CD','Release Management']
    },
    {
      company: 'GFT Italia',
      location: 'Italy',
      title: 'Senior Manager',
      period: 'apr 2023 - giu 2025',
      duration: '2 anni 3 mesi',
      description_it: 'Ha coordinato progetti digitali con responsabilita su pianificazione, execution e delivery finale. Ha guidato team tecnici in contesti complessi, favorendo allineamento tra esigenze business e implementazione tecnica. Ha contribuito alla crescita organizzativa attraverso governance operativa e supporto ai colleghi.',
      description_en: 'Led digital initiatives with ownership over planning, execution, and final delivery. Managed technical teams in complex contexts, aligning business needs with technical implementation. Contributed to organizational growth through operational governance and team enablement.',
      skills: ['Project Management','Team Coordination','Stakeholder Management','Software Delivery']
    },
    {
      company: 'GFT Italia',
      location: 'Italy',
      title: 'Line Manager / Team Leader',
      period: 'nov 2017 - apr 2023',
      duration: '5 anni 6 mesi',
      description_it: 'Ha unito leadership di linea e contributo tecnico diretto su applicazioni web. Ha seguito persone e processi, promuovendo best practice di sviluppo e collaborazione efficace. Ha lavorato su sviluppo front-end, coaching e supporto operativo continuativo.',
      description_en: 'Combined line leadership with direct technical contribution on web applications. Oversaw people and processes, promoting development best practices and effective collaboration. Worked across front-end delivery, coaching, and ongoing operational support.',
      skills: ['Angular','JavaScript','Team Leadership','Coaching','Web Architecture']
    },
    {
      company: 'Euris',
      location: 'Italy',
      title: 'Analyst Programmer',
      period: 'gen 2017 - ott 2017',
      duration: '10 mesi',
      description_it: 'Sviluppo front-end per applicazioni web con attenzione alla qualita dell\'interfaccia e all\'integrazione con servizi applicativi. Utilizzo di Bootstrap, SQL, CSS3, HTML5, Java e AngularJS in un contesto di delivery strutturata.',
      description_en: 'Developed front-end web applications with focus on UI quality and integration with application services. Used Bootstrap, SQL, CSS3, HTML5, Java, and AngularJS in a structured delivery environment.',
      skills: ['TypeScript','Bootstrap','HTML5','CSS3','AngularJS','SQL']
    },
    {
      company: 'Quid Informatica spa',
      location: 'Firenze, Toscana, Italia',
      title: 'Java Developer – Front End',
      period: 'gen 2016 - dic 2016',
      duration: '1 anno',
      description_it: 'Sviluppo front-end e back-end su applicazioni web con stack Java. Attivita su Java, Maven, AngularJS e WordPress, con focus su qualita implementativa e affidabilita operativa.',
      description_en: 'Worked on both front-end and back-end web development with a Java-based stack. Activities included Java, Maven, AngularJS, and WordPress, with focus on implementation quality and operational reliability.',
      skills: ['Java','Maven','AngularJS','WordPress','Web Development']
    },
    {
      company: 'Smag S.I.',
      location: 'Macerata, Marche, Italia',
      title: 'Network / System Administrator',
      period: '2004 - dic 2015',
      duration: '12 anni',
      description_it: 'Esperienza pluriennale come freelancer in ambito sistemi e supporto tecnico. Attivita su amministrazione di rete, troubleshooting e sviluppo web, costruendo una base solida su affidabilita e problem solving.',
      description_en: 'Long-term freelance experience in systems and technical support. Worked on network administration, troubleshooting, and web development, building a strong foundation in reliability and problem solving.',
      skills: ['Windows','Network Administration','Troubleshooting','Web Development','C++']
    }
  ];

  educations = [
    {
      institution: "Università di Pisa",
      degree: "Master's Degree in Computer Science",
      year: '2015',
      grade: '107',
      activities: 'Web radio - Radiocicletta',
      skills: ['Computer Science','Software Engineering','Problem Solving']
    },
    {
      institution: 'Università di Pisa',
      degree: 'C1 English Certification',
      year: '2014',
      grade: 'C1 level',
      activities: '',
      skills: ['English','Professional Communication']
    },
    {
      institution: 'Università di Pisa',
      degree: 'B1 Plus English Course',
      year: '2013',
      grade: 'B1 Plus level',
      activities: 'English course',
      skills: ['English']
    },
    {
      institution: 'University of Cambridge',
      degree: 'Preliminary English Test (PET)',
      year: '2002',
      grade: 'B1 level',
      activities: 'English course',
      skills: ['English']
    },
    {
      institution: 'Università di Camerino',
      degree: 'Bachelor Degree in Computer Science',
      year: '1999 - 2002',
      grade: '',
      activities: 'Founder, Student association: Fazzini Scalo',
      skills: ['Computer Science','Software Foundations']
    }
  ];
}
